import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
import Bus from '@/util/eventBus';
import MagicService from '@/service/magic';
export default {
  methods: {
    bookAct: function bookAct() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.hasBook) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return MagicService.bookAct();

              case 5:
                res = _context.sent;

                if (res.data.is_book) {
                  _this.$store.dispatch('hasBookAct');
                }

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }))();
    },
    refreshTicketInfo: function refreshTicketInfo() {
      // 获得门票后刷新对应的状态
      if (this.isLiveEnd) {
        this.$store.dispatch('getHasDianboTicket');
      } else {
        this.$store.dispatch('getHasZhiboTicket');
      }

      this.bookAct();
      this.$store.dispatch('getBuyList');
    },
    bindEvent: function bindEvent() {
      var _this2 = this;

      Bus.$on('refreshTicketInfo', function (data) {
        _this2.refreshTicketInfo(data);
      });
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};